/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import { AuthConsumer } from "../../AuthContext";
import PlugLanding from "../PlugLanding/PlugLanding";
import copyZh from "../PlugLanding/copyZh";

/**
 * The Plug marketing site in Traditional Chinese. All markup lives in
 * PlugLanding; this only picks the language.
 */
class PlugZh extends Component {
  render() {
    return (
      <AuthConsumer>
        {({ i18n }) => <PlugLanding {...this.props} copy={copyZh} lang="zh" i18n={i18n} />}
      </AuthConsumer>
    );
  }
}

export default PlugZh;
